var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leak-source-data-cell"},[_c('div',{staticClass:"leak-source-data-cell__content"},[_vm._v(_vm._s(_vm.getSource))]),(_vm.hasSources)?_c('div',{staticClass:"leak-source-data-cell__help",on:{"click":_vm.onHelpClick}},[_c('v-icon',{staticClass:"material-icons-round"},[_vm._v("help")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }